import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Alert, useTheme } from '@mui/material'
// import TaskAltIcon from '@mui/icons-material/TaskAlt';

const AlertSuccess = ({ submitted, style, onClose }) => {
  const theme = useTheme()
  return (
    <>
      {submitted && (
        <Alert
          role="alert"
          icon={false}
          severity="success"
          style={{
            color: theme.palette.color.postive130,
            marginTop: '10px',
            backgroundColor: theme.palette.color.postive5,
            border: '1px solid #52BD94',
          }}
        >
          <FontAwesomeIcon icon={faCheckCircle} />
          {/* <TaskAltIcon sx={{ fontSize: 20, color: theme.palette.color.postive }} /> */}
          &nbsp; Thank you for updating your profile! Our team will review it shortly. Your changes will take effect
          immediately.
        </Alert>
      )}
    </>
  )
}

export default AlertSuccess
